(function () {
  'use strict';

  var OTHER_VALUE = '__other__';

  function endpoint(root, path) {
    return String(root || '').replace(/\/+$/, '') + path;
  }

  function resolveApiBase(configuredBase) {
    var host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return 'http://localhost:3000';
    }
    return configuredBase;
  }

  function setStatus(widget, message, tone) {
    var status = widget.querySelector('[data-bootlock-status]');
    if (!status) return;
    status.textContent = message || '';
    status.classList.remove('is-success', 'is-error');
    if (tone) status.classList.add('is-' + tone);
  }

  function option(value, label) {
    var element = document.createElement('option');
    element.value = value;
    element.textContent = label;
    return element;
  }

  function showInput(input, visible, required) {
    if (!input) return;
    input.classList.toggle('lg-bootlock-interest__input--visible', visible);
    input.required = !!required;
    if (!visible) input.value = '';
  }

  function showModelInfo(widget, visible) {
    var modelSelectWrap = widget.querySelector('[data-bootlock-model]')?.closest('.lg-bootlock-interest__select-wrap');
    var modelInfo = widget.querySelector('[data-bootlock-model-info]');

    if (modelSelectWrap) {
      modelSelectWrap.classList.toggle('lg-bootlock-interest__select-wrap--hidden', visible);
    }

    if (modelInfo) {
      modelInfo.classList.toggle('lg-bootlock-interest__inline-info--visible', visible);
    }
  }

  function getSelectedValue(select, otherInput) {
    if (select.value === OTHER_VALUE) return otherInput.value.trim();
    return select.value.trim();
  }

  function getText(widget, name, fallback) {
    var value = widget.getAttribute('data-' + name);
    return value || fallback;
  }

  function renderBrandOptions(widget, options) {
    var brandSelect = widget.querySelector('[data-bootlock-brand]');
    if (!brandSelect) return;
    brandSelect.innerHTML = '';
    brandSelect.appendChild(option('', getText(widget, 'label-select-brand', 'Select boot brand')));
    options.forEach(function (item) {
      brandSelect.appendChild(option(item.brand, item.brand));
    });
    brandSelect.appendChild(option(OTHER_VALUE, getText(widget, 'label-other-brand', 'Other / not listed')));
    brandSelect.disabled = false;
  }

  function renderModelOptions(widget, options) {
    var brandSelect = widget.querySelector('[data-bootlock-brand]');
    var modelSelect = widget.querySelector('[data-bootlock-model]');
    var modelOther = widget.querySelector('[data-bootlock-model-other]');
    if (!brandSelect || !modelSelect) return;

    var selected = brandSelect.value;
    var selectedConfig = options.find(function (item) {
      return item.brand === selected;
    });

    modelSelect.innerHTML = '';

    if (!selected || selected === OTHER_VALUE) {
      modelSelect.appendChild(
        option(
          OTHER_VALUE,
          selected === OTHER_VALUE
            ? getText(widget, 'label-enter-model-below', 'Enter model below')
            : getText(widget, 'label-select-brand-first', 'Select a brand first')
        )
      );
      modelSelect.value = OTHER_VALUE;
      modelSelect.disabled = selected !== OTHER_VALUE;
      showModelInfo(widget, selected === OTHER_VALUE);
      showInput(modelOther, selected === OTHER_VALUE, selected === OTHER_VALUE);
      return;
    }

    modelSelect.appendChild(option('', getText(widget, 'label-select-model', 'Select boot model')));
    (selectedConfig && selectedConfig.models ? selectedConfig.models : []).forEach(function (model) {
      modelSelect.appendChild(option(model, model));
    });
    modelSelect.appendChild(option(OTHER_VALUE, getText(widget, 'label-other-model', 'Other / not listed')));
    modelSelect.disabled = false;
    showModelInfo(widget, false);
    showInput(modelOther, false, false);
  }

  function initWidget(widget) {
    var apiBase = resolveApiBase(widget.getAttribute('data-api-base'));
    var form = widget.querySelector('[data-bootlock-interest-form]');
    var brandSelect = widget.querySelector('[data-bootlock-brand]');
    var modelSelect = widget.querySelector('[data-bootlock-model]');
    var brandOther = widget.querySelector('[data-bootlock-brand-other]');
    var modelOther = widget.querySelector('[data-bootlock-model-other]');
    var submit = widget.querySelector('[data-bootlock-submit]');
    var successMessage = widget.getAttribute('data-success-message') || 'Thanks. We saved your request.';
    var options = [];

    if (!form || !apiBase) return;

    fetch(endpoint(apiBase, '/api/bootlock-interest/options'), {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok) throw new Error(json.error || getText(widget, 'status-options-error', 'Could not load boot options'));
          return json.options || [];
        });
      })
      .then(function (loadedOptions) {
        options = loadedOptions;
        renderBrandOptions(widget, options);
        renderModelOptions(widget, options);
        if (submit) submit.disabled = false;
        setStatus(widget, '', null);
      })
      .catch(function (error) {
        console.error('[bootlock-interest] options failed', error);
        options = [];
        renderBrandOptions(widget, options);
        renderModelOptions(widget, options);
        if (submit) submit.disabled = false;
        setStatus(widget, getText(widget, 'status-options-error', 'We could not load the saved list, but you can still enter your boot manually.'), 'error');
      });

    brandSelect.addEventListener('change', function () {
      showInput(brandOther, brandSelect.value === OTHER_VALUE, brandSelect.value === OTHER_VALUE);
      renderModelOptions(widget, options);
    });

    modelSelect.addEventListener('change', function () {
      showInput(modelOther, modelSelect.value === OTHER_VALUE, modelSelect.value === OTHER_VALUE);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var brand = getSelectedValue(brandSelect, brandOther);
      var model = getSelectedValue(modelSelect, modelOther);
      var email = form.elements.email.value.trim();

      if (!brand || !model || !email) {
        setStatus(widget, getText(widget, 'status-required-error', 'Please enter brand, model and email.'), 'error');
        return;
      }

      if (submit) {
        submit.disabled = true;
        submit.textContent = getText(widget, 'button-sending', 'Sending...');
      }
      setStatus(widget, getText(widget, 'status-sending', 'Sending request...'), null);

      fetch(endpoint(apiBase, '/api/bootlock-interest'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          brand: brand,
          model: model,
          email: email,
          productHandle: widget.getAttribute('data-product-handle') || '',
          productTitle: widget.getAttribute('data-product-title') || '',
          pageUrl: window.location.href
        })
      })
        .then(function (response) {
          return response.json().then(function (json) {
            if (!response.ok) throw new Error(json.error || getText(widget, 'status-submit-error', 'Could not send request. Please try again.'));
            return json;
          });
        })
        .then(function () {
          form.reset();
          showInput(brandOther, false, false);
          showInput(modelOther, false, false);
          renderModelOptions(widget, options);
          setStatus(widget, successMessage, 'success');
        })
        .catch(function (error) {
          console.error('[bootlock-interest] submit failed', error);
          setStatus(widget, error.message || getText(widget, 'status-submit-error', 'Could not send request. Please try again.'), 'error');
        })
        .finally(function () {
          if (submit) {
            submit.disabled = false;
            submit.textContent = submit.getAttribute('data-label') || getText(widget, 'button-label', 'Send');
          }
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-bootlock-interest]').forEach(function (widget) {
      if (widget._bootlockInterestBound) return;
      widget._bootlockInterestBound = true;
      var submit = widget.querySelector('[data-bootlock-submit]');
      if (submit) submit.setAttribute('data-label', submit.textContent);
      initWidget(widget);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
